// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ReactToRactiveAdapter } from '../../ReactToRactiveAdapter';
import { AccountLookupDropDownForm } from '../../ReactControls/elements/AccountLookupDropDownForm';
export class AccountLookupDropDownFormRactive extends ReactToRactiveAdapter {
    constructor() {
        super();
    }
    attachEventHandlers(props) {
        const propsFromRactive = this.get('accountLookupDropDownFormProps');
        Object.assign(props, propsFromRactive);
        props.onClose = () => {
            this.fire('close');
        };
    }
}
ReactToRactiveAdapter.extendWith(AccountLookupDropDownFormRactive, {
    template: '<div class="account-lookup-drop-down-form-wrapper"></div>',
    mountContainer: '.account-lookup-drop-down-form-wrapper',
    reactComponent: AccountLookupDropDownForm,
    data: function () {
        return {
            accountLookupDropDownFormProps: null
        };
    }
});
